
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gucjn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a62272d98aa46e2dbdd2cfd0bd6fea8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c008ff7f66f895a1$var$_react = $c008ff7f66f895a1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c008ff7f66f895a1$var$_iconNew = $c008ff7f66f895a1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c008ff7f66f895a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ZoomOut".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/zoom-out
 * Usage guidance:
 * Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c008ff7f66f895a1$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $c008ff7f66f895a1$var$_react.default.createElement($c008ff7f66f895a1$var$_iconNew.default, Object.assign({
        name: "ZoomOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7m9 .75H4v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$c008ff7f66f895a1$var$ZoomOutIcon.displayName = 'ZoomOutIcon';
var $c008ff7f66f895a1$var$_default = module.exports.default = $c008ff7f66f895a1$var$ZoomOutIcon;

});


//# sourceMappingURL=zoom-out.1f056e4e.js.map
